$( function () {
  const $window = $( window )
  const $body = $( 'body' )
  const $drawer = $( '#drawer' )
  const $searchForm = $( '.search-form' )

  if ( $body.hasClass( 'no-header-menu' ) ) return

  // 1. Clone Menu immediately
  // We clone the site-header into the drawer
  const $menuClone = $( ".site-header" ).clone()
  $( '.drawer' ).append( $menuClone )

  // 2. Helper functions for state
  const openMenu = () => {
    $body.addClass( 'open' ).css( 'overflow', 'hidden' )
  }

  const closeMenu = () => {
    $body.removeClass( 'open' ).css( 'overflow', '' )
  }

  // 3. Event Listeners (Using Delegation for Cloned Elements)

  // Search Toggles
  $body.on( 'click', '.search-container a', function ( e ) {
    e.preventDefault()
    $searchForm.addClass( 'active' )
  } )

  $body.on( 'click', '.search-close-container > i', function () {
    $searchForm.removeClass( 'active' )
  } )

  // Menu Toggles (Delegated so it finds #closeBtn inside the clone)
  $body.on( 'click', '#burgerBtn', function () {
    $body.hasClass( 'open' ) ? closeMenu() : openMenu()
  } )

  // Close via Close Button or Backdrop
  $body.on( 'click', '#closeBtn, #backdrop', function () {
    closeMenu()
  } )

  // 4. Global Keydown (Escape Key)
  $( document ).on( 'keydown', function ( e ) {
    if ( e.key === 'Escape' && $body.hasClass( 'open' ) ) {
      closeMenu()
    }
  } )

  // 5. Accessibility: Focus Trap
  $( document ).on( 'focusin', function ( e ) {
    if ( $body.hasClass( 'open' ) && !$drawer[ 0 ].contains( e.target ) ) {
      const $focusable = $drawer.find( 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])' )
      if ( $focusable.length ) $focusable.first().focus()
    }
  } )

  // 6. Optimized Resize
  let resizeTimer
  $window.on( 'resize', function () {
    clearTimeout( resizeTimer )
    resizeTimer = setTimeout( function () {
      // Logic: If screen gets large, close the mobile menu automatically
      if ( $window.width() > 1024 && $body.hasClass( 'open' ) ) {
        closeMenu()
      }
    }, 250 )
  } )
} )